import { AppDefinition } from '../../types/apps';

export const ChatAppDefinition: AppDefinition = {
  appId: 'chat',
  name: 'Chat',
  version: '1.0.0',
  description: 'AI-powered chat interface with multiple models and conversation management',
  icon: {
    type: 'phosphor',
    phosphorIcon: 'ChatCircle',
    phosphorWeight: 'duotone',
    color: '#3b82f6',
    metadata: {
      source: 'app',
      appId: 'chat',
      isAppIcon: true
    }
  },
  events: {
    onMessageSent: 'chat.messageSent',
    onThreadCreated: 'chat.threadCreated',
    onModelChanged: 'chat.modelChanged'
  },
  entityTypes: ['ChatThread', 'Message'],
  component: 'ChatApp',
  requiresProps: false,
  requiresEntity: false,
  hotkeys: {
    'cmd+enter': 'sendMessage',
    'cmd+n': 'createThread',
    'cmd+m': 'switchModel',
  },
  features: [
    'Multiple AI model support',
    'Conversation threading',
    'Message history',
    'Source entity integration',
    'Real-time responses',
    'Model switching',
    'Export conversations'
  ],
  experimental: true,
}; 